export default __webpack_public_path__ + "static/media/photo.52583060.jpg";